import React from "react";
import { useTranslation } from "react-i18next";
import { StyledModal, StyledH2, StyledLabel } from "@aureskonnect/react-ui";
import { ModalBody, ModalFooter, ModalHeader } from "reactstrap";

import { capitalize } from "@helpers/general";

import { CustomMainColorButton } from "@components/Common/CustomMainColorButton";
import { CustomSecondaryColorButton } from "@components/Common/CustomSecondaryColorButton";

type ConfirmationInitializationMessageType = {
    isModalOpened: boolean;
    setIsModalOpened: Function;
    setIsEdited?: Function;
    setIsClicked?: Function;
    isClicked?: boolean;
    setIsInlineErrorCleared?: Function;
    // Explicit confirm handler. Prefer this over hijacking `setIsClicked`
    // (a boolean state setter) as a click handler: `onConfirm` is a typed
    // contract `() => void`, so a caller's intent is visible to the compiler
    // and survives any future change to the `setIsClicked` toggle semantics.
    // Runs on Validate, after the legacy setIsClicked toggle.
    onConfirm?: () => void;
};

export function ConfirmationInitializationMessage({
    isModalOpened,
    setIsModalOpened,
    setIsEdited = () => false,
    setIsClicked,
    isClicked,
    setIsInlineErrorCleared,
    onConfirm,
}: ConfirmationInitializationMessageType) {
    const { t } = useTranslation();
    return (
        <StyledModal toggle={true} isOpen={isModalOpened!} centered>
            <ModalHeader
                className="text-capitalize"
                toggle={() => {
                    setIsModalOpened(false);
                }}
            >
                <StyledH2>{capitalize(t("Alert"))}</StyledH2>
            </ModalHeader>
            <ModalBody>
                <StyledLabel className="pl-3 m-0">
                    {t("Do you want to confirm the reset of all fields ?")}
                </StyledLabel>
            </ModalBody>
            <ModalFooter className="border-top-0 ">
                <CustomSecondaryColorButton
                    outline
                    variant="light"
                    onClick={() => {
                        setIsModalOpened(false);
                    }}
                    rounded
                >
                    {t("Cancel")}
                </CustomSecondaryColorButton>
                <CustomMainColorButton
                    rounded
                    className="mr-2"
                    variant="primary"
                    onClick={() => {
                        setIsModalOpened(false);
                        setIsClicked && setIsClicked(!isClicked);
                        setIsEdited(false);
                        if (setIsInlineErrorCleared !== undefined) {
                            setIsInlineErrorCleared(true);
                        }
                        onConfirm?.();
                    }}
                >
                    {t("Validate")}
                </CustomMainColorButton>
            </ModalFooter>
        </StyledModal>
    );
}
